<template>
  <div class="modal-frame modal-large" :class="{active:isOpen}" data-modal="history-popup">
    <div class="modal-frame-content">
      <button @click="$emit('close')" class="btn-close" rel="button_close" type="button" data-modal-close>
        <svg class="svg-cross">
          <use href="/img/sprite.svg#svg-cross"></use>
        </svg>
      </button>
      <div class="modal-frame-header">
        <div class="h3">История изменений</div>
      </div>
      <div class="modal-frame-body scroll-y" v-if="historyLoaded">
        <div class="change-history-list">
          <!--single item-->
          <div v-for="manager in history" class="change-history-item">
            <div class="change-history-title flex">
              <div class="time-info">{{ manager.date }}</div>
              <div class="author-info">
                <p>{{ manager.user.name }}</p>
                <span>{{ manager.user.work }}</span>
              </div>
            </div>
            <!--single articul-->
            <div v-for="item in manager.artnumbers" class="change-history-card">
              <div class="info-list-item flex-column">
                <div class="muted-13">Артикул:</div>
                <div class="font-15">{{ item.artnumber }}</div>
              </div>
              <div class="change-history-block">
                <div class="label">
                  <span class="font-13">Было</span>
                </div>
                <div class="info-list-item">
                  <template v-for="(field, key) in item.fields">
                  <div class="muted-13">{{ getFieldLabel(key) }}:</div>
                  <div class="font-15">{{ field.old }}</div>
                  </template>
                </div>
              </div>
              <div class="change-history-block">
                <div class="label">
                  <span class="font-13">Стало</span>
                </div>
                <div class="info-list-item">
                  <template v-for="(field, key) in item.fields">
                  <div class="muted-13">{{ getFieldLabel(key) }}:</div>
                  <div class="font-15">{{ field.new }}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {bool} from "yup";
import {useI18n} from "vue-i18n";

export default {
  props: {
    isOpen: {
      type: bool,
      default: () => false,
    },
  },
  data: () => ({

  }),
  setup() {
    const { t } = useI18n();
    return { t };
  },
  created() {
    this.fetchHistory(this.$route.params.id);
  },
  computed: {
    ...mapGetters('history', [
      'history',
      'historyLoading',
      'historyError',
      'historyLoaded',
    ]),
  },
  methods: {
    ...mapActions('history', [
      'fetchHistory',
    ]),
    getFieldLabel(key) {
      const translationKey = `orderTable.${key}`;
      const label = this.t(translationKey);

      return label === translationKey ? key : label;
    },
  }
}
</script>
